export const formatDataTable = (data: any, code: string, parentCode: any, value:any) => {
  let result: any =  []
  data.filter((o: any) => o[parentCode] == value).map((a:any)=>{
    a.subs = formatDataTable(data, code, parentCode, a[code])
    result.push(a);
  });
  return result;
}

export const flatDataTable = (data: any) => {
  const dataCloned = JSON.parse(JSON.stringify(data))
  const dataFlatted: any = []
  dataCloned.map((o: any) => {
    dataFlatted.push(o)
    if (o.subs.length > 0) {
      o.subs.map((child: any) => {
        dataFlatted.push(child)
        if (child.subs.length > 0) {
          child.subs.map((children: any) => {
            dataFlatted.push(children)
            if (children.subs.length > 0) {
              children.subs.map((subChildren: any) => {
                dataFlatted.push(subChildren)
                if (subChildren.subs.length > 0) {
                  subChildren.subs.map((subChildren1: any) => {
                    dataFlatted.push(subChildren1)
                    if (subChildren1.subs.length > 0) {
                      subChildren1.subs.map((subChildren2: any) => {
                        dataFlatted.push(subChildren2)                        
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
    }
  })
  dataFlatted.map((o: any, i: any) => {
    delete o.subs
  })
  return dataFlatted
}

